import {Location} from '@angular/common';
import { appConfig, PRIVACY_OPTIONS, PRIVACY_DEFAULTS } from '../../../../_core/config/app-config.const';
import { Component, OnInit, OnDestroy, AfterViewInit, Injectable, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { CreateTangramService } from './crearte-tangram.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationService } from 'src/app/_core/services/validation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { query } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/_services/auth.service';
import { HttpParams } from '@angular/common/http';
import initTrimSlider ,{slideOne, slideTwo, setDurationInit} from './trim-slider'
import { CommonService } from 'src/app/_services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'src/app/modules/configuration/services/configuration.service';
import { AiService } from '../../services/ai.service';
import { CanvasService, CanvasCourse, CanvasPage, CanvasFile } from 'src/app/_services/canvas.service';


declare let $: any;
declare let gtag: Function;

@Component({
  selector: 'tangram-create-tangram',
  templateUrl: './create-tangram.component.html',
  styleUrls: ['./create-tangram.component.scss']
})
export class CreateTangramComponent implements OnInit, AfterViewInit, OnDestroy {
  private scrollHandler: () => void;
  @ViewChild('UnlockPremiumModalContent',  { static: true }) unlockPremiumModalContent!: TemplateRef<any>;
  @ViewChild('PasswordModalContent',  { static: true }) passwordModalContent!: TemplateRef<any>;
  @ViewChild('InviteModalContent',  { static: true }) inviteModalContent!: TemplateRef<any>;
  @ViewChild('AlertContent',  { static: true }) alertContent!: TemplateRef<any>;
  iconPath: string = appConfig.iconPath; // To store icon path from config
  imgPath: string = appConfig.imagePath;
  videoForm: FormGroup; // To represent video form
  public startTime: any
  public endTime: any
  public duration: string = "00:00:00"
  public currentVideoDetail: any = { _id: '' }; // To store current video detail
  public trackVideoDetail = {}; // To store track video detail
  public isVideoFormSubmitted: boolean = false; // To store status of video form submission
  public totalVideoSeconds: number = 0; // To store total video seconds
  public startTimeErrorMessage: string = ""; // To store start time error message 
  public endTimeErrorMessage: string = ""; // To store end time error message
  public isSaveSubmit: boolean = false; // To store status of video form submission
  public youtubeId: string = ""; // To store Youtube video id
  public alterMessage: string = ""; // To store alert message
  public isYoutubeIdValid: boolean = false; // To store Youtube video id valid or not
  public videoDuration: any;
      public stratDuration:string;
    public currentUser : any
    imageChangedEvent: any = '';
    displayStyle: string = 'none';
    savedThumbImage: any = '';
    croppedImagePreview: string = ''; // To store base64 preview of cropped image
  iFrameURL:any;
  originalUrl: any;
  pathwayId: string = ""; // To store pathway id
  videoId: string = ""; // To store video id
  pageType: string = "create"; // To store page type
  /** pass content processed data to the component */
  currentUserSubscription: Subscription;
  isUserLoggedIn: boolean = false;
  redirectToLoginOrDashboard: any; // To store redirection url either login or dashboard
  clickGetInfo: boolean = false; // To store the get info button click event 
  public platForm: string
  public contentProcessed: any = {
    data: 0
  };
  videoFormErrors = {
    pathwayId: '',
    videoType: '',
    youtubeVideoId: '',
    title: '',
    order: '',
    description: '',
    tagId: ''
  }; // To store errors
  videoFormValueChangesSubscription: Subscription;
  videoFormValidationMessages = { // To store pathway form validation
    'pathwayId': {
      'required': 'Pathway should be selected.',
    },
    'videoType': {
      'required': 'Type should be selected'
    },
    'youtubeVideoId': {
      'required': 'Youtube Video should not be empty.'
    },
    'order': {
      'required': 'Order should not be empty.'
    },
    'tagId': {
      'required': 'Tag should be selected.'
    }
  };
  maxBasicTangram: number = 0;
  maxBasicMedia: number = 0;
  maxPremiumTangram: number = 0;
  maxPremiumMedia: number = 0;
  
  // Password Protection Properties
  isPasswordProtected: boolean = false;
  tangramPassword: string = '';
  confirmPassword: string = '';
  passwordError: string = '';
  
  // Invite Only Properties
  invitedEmails: any[] = [];
  newInviteEmail: string = '';
  newInvitedEmails: string[] = [];
  inviteMessage: string = '';
  inviteError: string = '';
  selectedFile: File | null = null; // To store the selected file for cropping

  // Mode selection: which creation method is active
  activeMode: 'hyperlinks' | 'upload' | 'text' | 'canvas' | 'bulk' = 'hyperlinks';

  // ── Upload tab state ──
  uploadedFile: File | null = null;
  isDragging = false;

  // ── Text tab state ──
  pastedText = '';
  similarContent: Array<{ title: string; url: string; source: string; reason?: string }> = [];
  similarTangrams: Array<{ title: string; pathwayId: string; reason: string }> = [];
  aiRecommendations: Array<{ title: string; reason: string; url?: string; mediaType?: string }> = [];
  aiContentOverview: string = '';
  curatorDraft: { title: string; description: string; notes: string[] } = { title: '', description: '', notes: [] };

  // Feature 1 – AI Title & Description Editor preview state
  aiGeneratedTitle: string = '';
  aiGeneratedDescription: string = '';
  isAiTitleDescLoading: boolean = false;
  aiTitleDescLoadingProvider: '' | 'gemini' | 'openai' = '';
  enhancingDescriptionProvider: '' | 'gemini' | 'openai' = '';
  enhancingTitleProvider: '' | 'gemini' | 'openai' = '';
  lastAiTitleDescProvider: 'gemini' | 'openai' = 'gemini';
  curatorAssistantPlan: {
    modules: Array<{ title: string; summary: string; selected: boolean }>;
    suggestedContent: Array<{ title: string; url: string; reason: string; selected: boolean; source: string }>;
    missingTopics: string[];
    sequenceImprovements: string[];
  } = { modules: [], suggestedContent: [], missingTopics: [], sequenceImprovements: [] };
  musicPlaylistItems: Array<{ platform: string; url: string }> = [];
  isSimilarContentLoading: boolean = false;
  isSimilarTangramsLoading: boolean = false;
  isRecommendationLoading: boolean = false;
  isContentOverviewLoading: boolean = false;
  isEnhancingTitle: boolean = false;
  isEnhancingDescription: boolean = false;
  isCuratorAssistantLoading: boolean = false;
  isCuratorAssistantEnabled: boolean = true;
  curatorAssistantError: string = '';
  assistantTopic: string = '';
  assistantStepIndex: number = 1;

  // ── Canvas stepper state ──
  canvasStep = 1;
  canvasConnected = false;
  canvasConnecting = false;
  canvasLoadingCourses = false;
  canvasLoadingContent = false;
  canvasImporting = false;
  canvasInstanceUrl = 'https://canvas.instructure.com';
  canvasAccessToken = '';
  canvasUserName: string | null = null;
  canvasConnectError = '';
  canvasCourses: CanvasCourse[] = [];
  canvasSelectedCourse: CanvasCourse | null = null;
  canvasPages: (CanvasPage & { selected?: boolean })[] = [];
  canvasFiles: (CanvasFile & { selected?: boolean })[] = [];

  // ── Feedback & tooltip ──
  showFeedbackModal: boolean = false;
  tipContent = 'Curate a tangram with mixed media. Enter one hyperlink at a time.';

  // ── Privacy Settings Properties ──
  selectedPrivacyOption: string = PRIVACY_DEFAULTS.PRIVACY_OPTION; // Default to public
  isPasswordSet: boolean = false; // Track if password is successfully set
  showPrivacySettings: boolean = false; // Track if privacy settings should be shown

  // ── Canvas stepper helpers ──
  get canvasStepLabel(): string {
    switch (this.canvasStep) {
      case 1: return 'Select Course';
      case 2: return 'Select Pages';
      case 3: return 'Preview';
      case 4: return 'Create';
      default: return '';
    }
  }
  get isCanvasStepValid(): boolean {
    if (this.canvasStep === 1) return !!this.canvasSelectedCourse;
    if (this.canvasStep === 2) return this.canvasPages.some(p => p.selected) || this.canvasFiles.some(f => f.selected);
    return true;
  }
  get selectedCanvasPages(): any[] {
    return this.canvasPages.filter((page: any) => page.selected);
  }
  get selectedCanvasFiles(): any[] {
    return (this.canvasFiles || []).filter(f => f.selected);
  }
  setCanvasStep(step: number) {
    if (step >= 1 && step <= 4 && (step < this.canvasStep || this.isCanvasStepValid)) {
      this.canvasStep = step;
    }
  }
  nextCanvasStep() {
    if (this.isCanvasStepValid && this.canvasStep < 4) {
      this.canvasStep++;
    }
  }
  prevCanvasStep() {
    if (this.canvasStep > 1) {
      this.canvasStep--;
    }
  }
  selectCanvasCourse(course: CanvasCourse) {
    this.canvasSelectedCourse = course;
    this.loadCanvasCourseContent(course.id);
  }
  toggleCanvasPage(page: any) {
    page.selected = !page.selected;
  }
  toggleCanvasFile(file: any) {
    file.selected = !file.selected;
  }
  selectAllCanvasPages() {
    this.canvasPages.forEach(p => p.selected = true);
  }
  deselectAllCanvasPages() {
    this.canvasPages.forEach(p => p.selected = false);
  }

  // ── Canvas live integration ──
  checkCanvasStatus() {
    this.canvasService.getStatus().subscribe(
      (res) => {
        if (res && res.data && res.data.connected) {
          this.canvasConnected = true;
          this.canvasUserName = res.data.canvasUserName;
          this.canvasInstanceUrl = res.data.instanceUrl || this.canvasInstanceUrl;
          this.loadCanvasCourses();
        } else {
          this.canvasConnected = false;
        }
      },
      () => { this.canvasConnected = false; }
    );
  }

  connectCanvas() {
    this.canvasConnectError = '';
    if (!this.canvasInstanceUrl || !this.canvasAccessToken) {
      this.canvasConnectError = 'Enter both Canvas URL and access token.';
      return;
    }
    this.canvasConnecting = true;
    this.canvasService.connect(this.canvasInstanceUrl, this.canvasAccessToken).subscribe(
      (res: any) => {
        this.canvasConnecting = false;
        if (res && res.success) {
          this.canvasConnected = true;
          this.canvasUserName = res.data && res.data.canvasUserName;
          this.canvasAccessToken = '';
          this.toasterService.success('Canvas account connected');
          this.loadCanvasCourses();
        } else {
          this.canvasConnectError = (res && res.message) || 'Connection failed';
        }
      },
      (err) => {
        this.canvasConnecting = false;
        this.canvasConnectError = (err && err.error && err.error.message) || 'Connection failed. Check your URL and token.';
      }
    );
  }

  disconnectCanvas() {
    this.canvasService.disconnect().subscribe(() => {
      this.canvasConnected = false;
      this.canvasCourses = [];
      this.canvasSelectedCourse = null;
      this.canvasPages = [];
      this.canvasFiles = [];
      this.canvasStep = 1;
      this.canvasUserName = null;
      this.toasterService.info('Canvas account disconnected');
    });
  }

  loadCanvasCourses() {
    this.canvasLoadingCourses = true;
    this.canvasService.listCourses().subscribe(
      (res) => {
        this.canvasLoadingCourses = false;
        this.canvasCourses = (res && res.data) || [];
        if (this.canvasCourses.length === 0) {
          this.toasterService.info('No teacher courses found on your Canvas account.');
        }
      },
      (err) => {
        this.canvasLoadingCourses = false;
        const msg = (err && err.error && err.error.message) || 'Failed to load Canvas courses';
        this.toasterService.error(msg);
        if (err && err.status === 412) this.canvasConnected = false;
      }
    );
  }

  loadCanvasCourseContent(courseId: number) {
    this.canvasLoadingContent = true;
    this.canvasPages = [];
    this.canvasFiles = [];
    const pages$ = this.canvasService.listPages(courseId);
    const files$ = this.canvasService.listFiles(courseId);
    pages$.subscribe(
      (res) => { this.canvasPages = ((res && res.data) || []).map(p => ({ ...p, selected: false })); },
      () => { /* ignore — files may still succeed */ }
    );
    files$.subscribe(
      (res) => {
        this.canvasLoadingContent = false;
        this.canvasFiles = ((res && res.data) || []).map(f => ({ ...f, selected: false }));
      },
      () => { this.canvasLoadingContent = false; }
    );
  }

  createTangramFromCanvas() {
    if (!this.canvasSelectedCourse) return;
    const pages = this.selectedCanvasPages.map(p => ({ url: p.url, title: p.title }));
    const files = this.selectedCanvasFiles.map(f => ({ url: f.url, displayName: f.displayName, contentType: f.contentType }));
    if (pages.length === 0 && files.length === 0) {
      this.toasterService.error('Select at least one page or file to import');
      return;
    }
    this.canvasImporting = true;
    const resolvedCanvasRole =
      this.canvasSelectedCourse.enrollmentRole
      || ((this.canvasSelectedCourse.enrollments && this.canvasSelectedCourse.enrollments[0] && (this.canvasSelectedCourse.enrollments[0].role || this.canvasSelectedCourse.enrollments[0].type)) || '');
    this.canvasService.importCourse({
      courseId: this.canvasSelectedCourse.id,
      courseName: this.canvasSelectedCourse.name,
      canvasRole: resolvedCanvasRole || undefined,
      tangramRole: this.resolveTangramRoleFromCanvasRole(resolvedCanvasRole),
      pages,
      files,
    }).subscribe(
      (res: any) => {
        this.canvasImporting = false;
        if (res && res.success) {
          this.toasterService.success(`Imported ${res.data.mediaCount} items from Canvas`);
          this.router.navigate(['/share-tangram'], { queryParams: { pathwayId: res.data.pathwayId } });
        } else {
          this.toasterService.error((res && res.message) || 'Import failed');
        }
      },
      (err) => {
        this.canvasImporting = false;
        const msg = (err && err.error && err.error.message) || 'Failed to import Canvas content';
        this.toasterService.error(msg);
      }
    );
  }

  private resolveTangramRoleFromCanvasRole(canvasRole: string): 'STUDENT' | 'TA' | 'CURATOR' {
    const normalized = String(canvasRole || '').toLowerCase();
    if (normalized.includes('ta') || normalized.includes('assistant')) {
      return 'TA';
    }
    if (normalized.includes('teacher') || normalized.includes('instructor')) {
      return 'CURATOR';
    }
    return 'STUDENT';
  }

  // ── Upload helpers ──
  onFileDropped(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    const files = event.dataTransfer ? event.dataTransfer.files : null;
    if (files && files.length > 0) {
      this.handleFileSelect(files[0]);
    }
  }
  onFileDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }
  onFileDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }
  onFileBrowse(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFileSelect(input.files[0]);
    }
  }
  handleFileSelect(file: File) {
    const allowedTypes = [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/plain',
    ];
    if (!allowedTypes.includes(file.type)) {
      this.toasterService.error('Please upload a PDF, DOCX, or TXT file.');
      return;
    }
    this.uploadedFile = file;
    this.toasterService.success(`"${file.name}" ready — extraction coming soon!`);
  }
  clearUploadedFile() {
    this.uploadedFile = null;
  }
  constructor(
    private location: Location,
    private authservice: AuthService,
    private createTangramService: CreateTangramService,
    private formBuilder: FormBuilder,
    private _validation: ValidationService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToastrService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private modalService: NgbModal,
    private configurationService: ConfigurationService,
    private aiService: AiService,
    private canvasService: CanvasService,
  ) {
    // build video form
    this.buildVideoForm();
    // check for page type
    this.handleFlow();
  }
  /**
   * fetching the title and description from URL 
   * @param url 
   * @returns title and description
   */
  getTitle(url: string) {
    return this.http.get(url, {responseType: 'text', params : {
        'interceptorNotNeeded' : 'true'
      }
    })
    .pipe(
      map(html => {
        const titleMatch = /<title>(.*?)<\/title>/i.exec(html);
        const descriptionMatch = /<meta\s+name="description"\s+content="(.*?)"\s*\/?>/i.exec(html);
        
        const title = titleMatch ? titleMatch[1] : '';
        const description = descriptionMatch ? descriptionMatch[1] : '';

        return { title, description };
      }),
      catchError(error => {
        // console.error('Error fetching website info:', error);
        // Throw a custom error with a status code
        const status = 500; // Use the existing status if available, or default to 500
        const customError = new Error(`Unable to retrieve website info (Status: ${status})`);
        customError['status'] = status; // Add a custom property to store the status code
        return throwError(customError);
      })
    );    
  }
  ngOnInit() {
    this.currentUserSubscription = this.authservice.currentUser.subscribe((currentUser) => {
      this.currentUser = currentUser;
      this.isUserLoggedIn = currentUser ? true : false;
      this.redirectToLoginOrDashboard = this.isUserLoggedIn ? '/dashboard' : '/login';
    });
    // Initialize the trim-slider module for BOTH create and edit flows.
    // The slider module keeps `subscriptionActive` in its own closure, and
    // `setDurationInit` (called later from getVideoDetail / getYoutubeVideoDetail)
    // reads it to decide the slider max. Without this call in edit mode the
    // max was left at the default 180s, breaking start/end-time editing for
    // subscribed users on existing media.
    if (this.currentUser) {
      initTrimSlider(this.currentUser.subscriptionActive);
    }
    this.getConfigurations();

  }

  ngAfterViewInit(): void {
    // Scroll-reveal behaviour: header is transparent at the top of the page,
    // and the brand gradient (`.top-header.sticky` — see _header.scss /
    // _custom.scss `.gradient-bg`) fades in once the user scrolls past 10px.
    const $header = $('.top-header');

    this.scrollHandler = () => {
      if (window.scrollY > 10) {
        $header.addClass('sticky');
      } else {
        $header.removeClass('sticky');
      }
    };
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  ngOnDestroy(): void {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }

  backButton() {
    // In edit-media mode (edit-tangram-video/:videoId) the user may have
    // arrived from either the draft edit-tangram view OR the published
    // dashboard. Forcing /dashboard/:pathwayId would strand draft users on
    // the published UI — use location.back() to preserve their origin.
    if (this.pageType === 'edit') {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigate(['/dashboard']);
      }
      return;
    }
    // Create mode with an existing pathwayId (adding media to a tangram)
    // — the user came from the edit-tangram flow, so back = history.back().
    if (this.pathwayId) {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigate(['/dashboard', this.pathwayId]);
      }
      return;
    }
    // Plain create mode — no pathway context yet.
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
  slideOne(){
    const startTime = slideOne()
    this.videoForm.patchValue({
      startTime: startTime
    })
  }
  slideTwo(){
    const endTime = slideTwo()
    this.videoForm.patchValue({
      endTime: endTime
    })
  }
  // Build video form
  buildVideoForm() {
    this.videoForm = this.formBuilder.group({
      _id: [null],
      pathwayId: [null],
      videoType: [null],
      youtubeVideoId: ['', Validators.required],
      title: [''],
      order: [''],
      description: [''],
      thumbnail: this.formBuilder.group({
        smallURL: [''],
        mediumURL: ['']
      }),
      duration: this.formBuilder.group({
        hour: [0],
        minute: [0],
        second: [0]
      }),
      tagId: [null],
      startTime: [null],
      endTime: [null],
      startTimeInSecond: [null],
      endTimeInSecond: [null],
    });
    this.getValidationErrors();

    // Get validation error when video form values get changed
    this.videoFormValueChangesSubscription = this.videoForm.valueChanges.subscribe(() => this.getValidationErrors());
  }


  // Get validation errors
  getValidationErrors() {
    this.videoFormErrors = this._validation.getValidationErrors(this.videoForm, this.videoFormValidationMessages);
  }

  /**
   * Called when video form gets submitted and another video can be saved 
   */
  saveAnotherVideo() {
    this.isSaveSubmit = false;
  }

  /**
   * Called when video form gets submitted and another video can be saved 
   */
  saveVideo() {
    this.isSaveSubmit = true;
  }

  onDashboardClick() {
    this.router.navigate(['/my-tangram']);
  }

  openFeedbackModalInSmallDevice() {
    this.showFeedbackModal = !this.showFeedbackModal;
  }

  /**
   * Called when video form gets submitted
   * @param isVideoFormValid isVideoFormValid to check whether video form is valid or not
   */
  onSubmit(isVideoFormValid: boolean) {
    let isValidate: boolean = false;
    if(this.clickGetInfo || this.pageType == 'edit'){
      isValidate = true
    }
    let startTimeInSecond;
    let endTimeInSecond;
    this.isVideoFormSubmitted = true; // Indicate that form is submitted

    const startTime = this.startTime;
    const endTime = this.endTime;
    this.totalVideoSeconds = this.convertTimeToSecond(this.videoForm.value.duration);
    if (startTime) {
      startTimeInSecond = this.convertTimeToSecond(startTime);
      if (startTimeInSecond >= this.totalVideoSeconds && this.platForm == "YouTube"){
        this.startTimeErrorMessage = "Start time should not be bigger that video duration.";
        isValidate = false;
      } else {
        this.startTimeErrorMessage = null;
      }
    } else {
      startTimeInSecond = this.startTimeValue();
    }

    if (endTime) {
      endTimeInSecond = this.convertTimeToSecond(endTime);
      if (endTimeInSecond > this.totalVideoSeconds && this.platForm == "YouTube") {
        this.endTimeErrorMessage = "End time should not be bigger than video duration.";
        isValidate = false;
      } else {
        this.endTimeErrorMessage = null;
      }
    } else {
      endTimeInSecond = this.endTimeValue();
    }


    if (!startTime && !endTime) {
      startTimeInSecond = this.startTimeValue();
      endTimeInSecond = this.endTimeValue();
    }

    this.videoForm.value.startTimeInSecond = startTimeInSecond;
    this.videoForm.value.endTimeInSecond = endTimeInSecond;

    if (isValidate) {
      if (startTimeInSecond > endTimeInSecond) {
        this.startTimeErrorMessage = "Start time should not be bigger than End time";
        isValidate = false;
      } else {
        this.startTimeErrorMessage = null;
      }
    }


    let tagId = this.isYoutubeIdValid ? 'Video' : '';
    const data = JSON.parse(JSON.stringify(this.videoForm.value));
    let placeHolderPath = ''
    data._id = this.videoId ? this.videoId : null;
    data.pathwayId = this.pathwayId;
    if( /\bhttps?:\/\/\S+\.(?:png|jpe?g|gif|bmp|ico|svg)\b/g.test(this.youtubeId) || this.youtubeId.includes('image')){
      tagId = 'Photo'
      // Only set thumbnail if no custom thumbnail is provided
      if(!this.savedThumbImage){
        data.thumbnail = { smallURL: this.youtubeId, mediumURL:  this.youtubeId }
      }
    }
    if(this.youtubeId.includes('pdf')){
      placeHolderPath = 'assets/img/videos/PDF_Placeholder.png'
      tagId = 'PDF'
    }
    if(this.youtubeId.includes('spotify')){
      tagId = 'Audio'
    }
    if(this.youtubeId.includes('docs') || this.youtubeId.includes('drive')){
      placeHolderPath = 'assets/img/videos/Drive_Placeholder.png'
      tagId = 'Document'
    }
    data.tagId = tagId;
    if(data.tagId == ''){
      placeHolderPath = 'assets/img/videos/Blog_Articles_Placeholder.png'
    }
    
    // Set default placeholders only if no custom thumbnail is provided
    if(placeHolderPath && !this.savedThumbImage && !this.videoId){
      data.thumbnail = { smallURL: placeHolderPath, mediumURL:  placeHolderPath }
    }
    
    data.videoType = '';
    if (this.platForm == 'Spotify') {
      data.songUrl = this.originalUrl;
    }
    data.youtubeVideoId = this.youtubeId;
    data.platForm = this.platForm;
    
    // Add privacy settings data with validation (only for new tangrams, not when adding media to existing tangram)
    if (!this.pathwayId) {
      // Check if password protected is selected but no password is entered or password is not properly set
      if (this.selectedPrivacyOption === PRIVACY_OPTIONS.PASSWORD_PROTECTED && 
          (!this.tangramPassword || this.tangramPassword.trim() === '' || !this.isPasswordSet)) {
        // Fallback to public if password protection is selected but no password is provided
        console.log('Password protection selected but no valid password provided. Falling back to public privacy.');
        data.privacyOption = PRIVACY_DEFAULTS.PRIVACY_OPTION;
        data.isPasswordProtected = PRIVACY_DEFAULTS.IS_PASSWORD_PROTECTED;
        data.password = '';
        
        // Show notification to user about fallback to public
        this.toasterService.warning('Password protection was selected but no password was provided. Tangram will be set to public.', 'Privacy Setting Updated');
      } else {
        data.privacyOption = this.selectedPrivacyOption;
        data.isPasswordProtected = this.isPasswordProtected;
        data.password = this.isPasswordProtected ? this.tangramPassword : '';
        data.isInviteOnly = this.selectedPrivacyOption === PRIVACY_OPTIONS.INVITE_ONLY;
        data.isPrivate = this.selectedPrivacyOption === PRIVACY_OPTIONS.PRIVATE;
      }
    } else {
      // When adding media to existing tangram, don't include privacy settings
      console.log('Adding media to existing tangram - privacy settings not applicable');
    }
    
    console.log('this.savedThumbImage: ', this.savedThumbImage);
    
    if(this.savedThumbImage && this.videoId){
      // If savedThumbImage is a File object, append it to the data
      if (this.savedThumbImage instanceof File) {
        data.thumbnail = { smallURL: this.savedThumbImage, mediumURL: this.savedThumbImage };
        // Remove any existing thumbnailFile when sending URLs
        delete data.thumbnailFile;
      } else {
        // If it's already a URL string, use it directly
        data.thumbnail = { smallURL: this.savedThumbImage, mediumURL: this.savedThumbImage };
        // Remove any existing thumbnailFile when sending URLs
        delete data.thumbnailFile;
      }
    }
    if (isValidate) {
      if (isVideoFormValid) {
        this.createTangramService.getPathwayOrVideoCount(this.pathwayId).subscribe((response : any) => {
          if(!this.currentUser.subscriptionActive){
            if(!this.pathwayId && response.count >= this.maxBasicTangram ){
              this.openUnlockPremium(this.unlockPremiumModalContent)
              return;
            }else if(this.pathwayId && response.count >= this.maxBasicMedia){
              this.openUnlockPremium(this.unlockPremiumModalContent)
              return;
            }
          }          
          // Final cleanup to ensure only one thumbnail field is sent
          this.cleanupThumbnailData(data);
          
          this.createTangramService.saveVideo(data).subscribe((response: any) => {
            gtag('event', 'create_tangram', {
              'tangram_id': response.pathwayId,
            });
            
            // Handle invite only invitations after tangram creation
            if (this.selectedPrivacyOption === PRIVACY_OPTIONS.INVITE_ONLY && this.invitedEmails.length > 0) {
              this.sendInviteOnlyInvitations(response.pathwayId);
            }
            
            this.resetVideoForm();
            if (this.isSaveSubmit) {
              if(data.isPrivate){
                this.router.navigate(['/dashboard', response.pathwayId], { replaceUrl:true });
              }else{
                this.router.navigate(['/share-tangram'], { queryParams: { pathwayId: response.pathwayId} });
              }
            } else {
              this.router.navigate(['/create-tangram'], { queryParams: { pathwayId: response.pathwayId}, replaceUrl:true });
            }
          },(error) => {
            console.log('error: ', error);
          });
        })

      }
    }
  }

  /**
   * Clean up thumbnail data to ensure only one thumbnail field is sent
   */
  cleanupThumbnailData(data: any) {
    // Remove thumbnailFile if it exists (no longer used)
    if (data.thumbnailFile) {
      delete data.thumbnailFile;
    }
    
    // Ensure thumbnail structure is clean
    if (data.thumbnail) {
      // If thumbnail contains File objects, ensure both smallURL and mediumURL are Files
      if (data.thumbnail.smallURL instanceof File && data.thumbnail.mediumURL instanceof File) {
        // Both are files, keep as is
      } else if (data.thumbnail.smallURL && !(data.thumbnail.smallURL instanceof File)) {
        // If smallURL is not a File, ensure mediumURL is also not a File
        if (data.thumbnail.mediumURL instanceof File) {
          data.thumbnail.mediumURL = data.thumbnail.smallURL;
        }
      }
    }
  }

  /**
   * Reset video formiFrameURL
   */
  resetVideoForm() {
    this.videoForm.reset();
    this.videoForm.patchValue({
      duration: { hour: 0, minute: 0, second: 0 }
    })
    this.isVideoFormSubmitted = false;
    this.currentVideoDetail = {
      _id: ''
    }
    // this.originalUrl = '';
    this.duration = "00:00:00";
    this.videoDuration = null;
    this.stratDuration=null;
    this.iFrameURL = '';
    // Clear thumbnail-related properties
    this.savedThumbImage = '';
    this.selectedFile = null;
    this.imageChangedEvent = '';
    this.croppedImagePreview = '';
    // Reset the file input
    const fileInput: HTMLInputElement = document.getElementById('fileInput') as HTMLInputElement;
    if(fileInput){
      fileInput.value = null;
    }
    
    // Reset privacy settings
    this.selectedPrivacyOption = PRIVACY_DEFAULTS.PRIVACY_OPTION;
    this.isPasswordSet = false;
    this.isPasswordProtected = false;
    this.tangramPassword = '';
    this.confirmPassword = '';
    this.passwordError = '';

    initTrimSlider(this.currentUser.subscriptionActive)
  }

  handlePaste(event?: any){
    this.resetVideoDetails()
  }
  
  resetVideoDetails(){
    const youtubeVideoIdValue = this.videoForm.get('youtubeVideoId').value;
    this.videoForm.reset({
      _id: null,
      pathwayId: null,
      videoType: null,
      youtubeVideoId: youtubeVideoIdValue, // Preserve the youtubeVideoId value
      title: '',
      order: '',
      description: '',
      thumbnail: {
        smallURL: '',
        mediumURL: ''
      },
      thumbnailFile: null,
      duration: {
        hour: 0,
        minute: 0,
        second: 0
      },
      tagId: null,
      startTime: null,
      endTime: null,
      startTimeInSecond: null,
      endTimeInSecond: null
    });
  }

  /**
   * 
   * @param ms milliseconds
   * @returns updated time format
   */
  convertMsToTimeObject = (ms: any) => {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
  
    return {
      hour: hours % 24,
      minute: minutes % 60,
      second: seconds % 60,
    };
  };

  /**
   * Convert youtube duration to hour, minute and second
   * @param duration
   */
  youtubeDurationToHourMinuteSecond(duration) {
    // Format to store video duration
    const videoDuration = { hour: 0, minute: 0, second: 0 };

    // Remove PT text from the youtube duration
    duration = duration.replace("PT", '');

    // Get index of hour duration from youtube duration, if available then store it in hour
    const hourIndex = duration.indexOf('H');
    if (hourIndex != -1) {
      videoDuration.hour = parseInt(duration.substring(0, hourIndex));
    }

    // Get index of minute duration from youtube duration, if available then store it in minute
    const minuteIndex = duration.indexOf('M');
    if (minuteIndex != -1) {
      videoDuration.minute = parseInt(duration.substring(hourIndex + 1, minuteIndex));
    }

    // Get index of second duration from youtube duration, if available then store it in second
    const secondIndex = duration.indexOf('S');
    if (secondIndex != -1) {
      videoDuration.second = parseInt(duration.substring(minuteIndex + 1, secondIndex));
    }

    // Return video duration
    return videoDuration;
  }

  /**
   * Get detail's of public url
   */
  getPublicLinkDetails() {
    this.getYoutubeId();
    this.clickGetInfo = true;
    this.savedThumbImage = ''
    this.croppedImagePreview = '';
    // Reset similar-content state so the user can manually load it via the
    // "Load with AI" button — auto-fetching here used to spam the AI on every
    // URL paste.
    this.similarContent = [];
    if(this.platForm != 'YouTube') {
      this.currentVideoDetail = {
        _id: ''
      }
    }
    
    if (this.platForm == 'YouTube') {
      this.getYoutubeVideoDetail(this.youtubeId);
    } else if (this.platForm == 'Spotify') {
      this.getSpotifyUrlInfo(this.youtubeId);
    }else if(!this.isYoutubeIdValid && this.platForm == 'Other'){
      this.videoForm.patchValue({
        title: '',
        description: ''
      })
      this.iFrameURL = this.getSafeUrl(this.youtubeId)
      // display title and description for image
      if( /\bhttps?:\/\/\S+\.(?:png|jpe?g|gif|bmp|ico)\b/g.test(this.youtubeId)){
        const urlParts = this.youtubeId.split("/");
        const filenameWithQueryParams = urlParts[urlParts.length - 1];
        const filenameWithoutQueryParams = filenameWithQueryParams.split("?")[0];
        const [imageName] = filenameWithoutQueryParams.split(".");
        this.videoForm.patchValue({
          title: imageName,
          description: ''
        })
      }
      // display title and description for workspace ex. document or spreadsheet
      else if(this.youtubeId.includes('document') || this.youtubeId.includes('spreadsheets') || this.youtubeId.includes('drive')){
        const urlParts = this.youtubeId.split("/");
        urlParts[urlParts.length - 1] = 'preview'
        const newURL = urlParts.join('/')
        this.iFrameURL = this.getSafeUrl(newURL)
        // TODO: temporary set the title and description for drive like this
        if( this.youtubeId.includes('drive')){
          this.getTitle(this.youtubeId).subscribe(
            (data) => {
              this.videoForm.patchValue({
                title: data.title,
                description: data.description
              })
            },
            (error) => {
              console.error('Error fetching website title:', error);
          });
        }else{
          this.getWorkSpaceInfo(this.youtubeId)
        }
      }
      // display title and description for articles
      else{
        const notAddProxy = ['wikipedia', 'axios', 'cbsnews', 'instructure.com', 'canvas-user-content.com', 'inst-fs-iad-prod.inscloudgate.net'];
        const enCodeURL = encodeURIComponent(this.youtubeId)
        let newProxyURL = environment.proxyWorkerURL + '?id=1&interceptorNotNeeded=true&apiURL=' + enCodeURL;
        if(!environment.production){
          newProxyURL = environment.proxyWorkerURL + '?id=2&interceptorNotNeeded=true&apiURL=' + enCodeURL;
        }
        
        const notNeedProxy = notAddProxy.some((value) => this.youtubeId.includes(value))
        if(notNeedProxy){
          this.iFrameURL = this.getSafeUrl(this.youtubeId)
        }else{
          this.iFrameURL = this.getSafeUrl(newProxyURL)
        }
        
        // Get the title and description from proxyURL
        this.getTitle(newProxyURL).subscribe(
          (data) => {
            this.videoForm.patchValue({
              title: data.title,
              description: data.description
            })
          },
          (error) => {
            console.error('Error fetching website title:', error);
          }
        );
      }
      return true;
    }
  }

  /**
   * Get youtube video details
   * @param youtubeId youtube id
   * @
   */
  getYoutubeVideoDetail(youtubeId: string) {
    this.createTangramService.getYoutubeVideoDetail(youtubeId).subscribe((data: any) => {
      let title, description = "";
      let duration = { hour: 0, minute: 0, second: 0 };
      const initstart = { hour: 0, minute: 0, second: 0 };
      let thumbnail = { smallURL: '', mediumURL: '' };
      // Check video detail available or not
      if (data.items.length) {
        const [video] = data.items; // To get first video detail
        const { snippet, contentDetails } = video; // To get snippet and content details
        const { thumbnails } = snippet; // To get thumbnail details
        // Convert youtube duration to separate hour, minute and second
        duration = this.youtubeDurationToHourMinuteSecond(contentDetails.duration);
        title = snippet.title;
        description = snippet.description;
        thumbnail = { smallURL: thumbnails.default.url, mediumURL: thumbnails.medium.url }
        // Bind fetched detail(title, description, duration and thumbnail) into vidoe form to display
        this.videoForm.patchValue({
          title: title,
          description: description,
          duration: duration,
          thumbnail: thumbnail
        });
        this.videoDuration = this.convertTimeToSecond(duration)
        this.videoDuration = this.secondsToTime(this.videoDuration)
        this.stratDuration = "00:00:00"
        
        //handle current video
        this.handleCurrentVideo(true);
        setDurationInit(initstart, duration,this.pageType, {});
      } else {
        this.toasterService.error('Media does not exist');
        this.resetVideoForm();
      }
    })
  }

  /**
   * Get spotify url details
   * @param url spotify url
   * @
   */
  getSpotifyUrlInfo(url: string) {
    this.createTangramService.getSpotifyUrlDetail(url).subscribe((response: any) => {
      const data = response.data;
      let duration = { hour: 0, minute: 0, second: 0 };
      let title, description = "";
      const placeHolderPath = 'assets/img/videos/audio-placeholder.jpg';
      let thumbnail = { smallURL: placeHolderPath, mediumURL: placeHolderPath };
      // Check video detail available or not
      if (data) {
        title = data.title || "";
        description = data.description || "";
        duration = this.convertMsToTimeObject(data.duration_ms);
        if(data.thumbnail_url){
          thumbnail = { smallURL: data.thumbnail_url, mediumURL: data.thumbnail_url }
        }
        this.iFrameURL = this.getSafeUrl(data.iframe_url);
        this.originalUrl = data.iframe_url;
        // Bind fetched detail(title, description, duration and thumbnail) into vidoe form to display
        this.videoForm.patchValue({
          title: title,
          description: description,
          duration: duration,
          thumbnail: thumbnail
        });
        this.videoDuration = this.convertTimeToSecond(duration)
        this.videoDuration = this.secondsToTime(this.videoDuration)
        this.stratDuration = "00:00:00"
        
        //handle current video
        // this.handleCurrentVideo(true);
        // setDurationInit(initstart, duration,this.pageType)
      } else {
        this.toasterService.error('Media does not exist');
        this.resetVideoForm();
      }
    },(err) => {
      this.resetVideoForm();
    })
  }
//   isValidURL(url) {
//     // Basic URL validation
//     var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
//         '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
//         '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
//         '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
//         '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
//         '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
//     return pattern.test(url);
// }
  /**
   * Get workspace url details
   * @param url workspace url
   * @
   */
  getWorkSpaceInfo(url: string){
    const data = {
      id : '',
      workspaceName : ''
    }
    if(url.includes('document')){
      let documentId = '';
      const match = url.match(/\/document\/d\/([a-zA-Z0-9_-]+)\/(edit|view)?/);
      if (match && match[1]) {
        documentId = match[1];
      }
      data.id = documentId;
      data.workspaceName = 'document'
    }
    if(url.includes('spreadsheets')){
      let spreadSheetId = ''
      const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9_-]+)\/(edit|view)?/);
      if (match && match[1]) {
        spreadSheetId = match[1];
      }
      data.id = spreadSheetId;
      data.workspaceName = 'spreadsheets'
    }
    // if(url.includes('file')){
    //   let spreadSheetId = ''
    //   const match = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)\/(edit|view)?/);
    //   if (match && match[1]) {
    //     spreadSheetId = match[1];
    //   }
    //   data.id = spreadSheetId;
    //   data.workspaceName = 'file'
    // }
    
    if(data.id){
      this.createTangramService.getGoogleWorkspaceDetails(data).subscribe((response: any) => {
        if(response.data){
          if(response.data.title){
            this.videoForm.patchValue({
              title: response.data.title,
              description: ''
            })
          }else if(response.data.properties){
            this.videoForm.patchValue({
              title: response.data.properties.title,
              description: ''
            })
          }
        }
      })
    }
  }
  
  
  /**
   * Load video
   * @param initial to set initial values — true for fresh "Get Info" fetches
   *                (reset trim window to 0→duration), false when opening an
   *                existing media record for edit (preserve its saved trim).
   */
  handleCurrentVideo(initial) {
    const formValue = this.videoForm.value;
    this.currentVideoDetail = { ...formValue };
    this.currentVideoDetail._id = 123;
    // Guard against malformed duration from backend (null/undefined) — the
    // downstream `convertTimeToSecond` dereferences .hour/.minute/.second
    // directly.
    const safeDuration = formValue.duration || { hour: 0, minute: 0, second: 0 };
    this.currentVideoDetail.duration = safeDuration;
    const totalSec = this.convertTimeToSecond(safeDuration);
    if (initial) {
      this.currentVideoDetail.startTimeInSecond = 0;
      this.currentVideoDetail.endTimeInSecond = totalSec;
    } else {
      // Respect the previously saved trim window so the video plays the
      // correct segment when re-opened for edit. Fall back to the full
      // duration when the backend didn't store a trim (endTimeInSecond=0
      // would otherwise make timeupdate fire `ended` immediately and the
      // video could never actually play).
      this.currentVideoDetail.startTimeInSecond =
        formValue.startTimeInSecond != null ? formValue.startTimeInSecond : 0;
      this.currentVideoDetail.endTimeInSecond =
        formValue.endTimeInSecond ? formValue.endTimeInSecond : totalSec;
    }
    // Ensure startTime/endTime objects exist on currentVideoDetail — the
    // video-detail component dereferences them in its seeked handler without
    // a null-check (videoDetail.startTime.hour) which would throw otherwise.
    this.currentVideoDetail.startTime = formValue.startTime || { hour: 0, minute: 0, second: 0 };
    this.currentVideoDetail.endTime = formValue.endTime || safeDuration;
    this.currentVideoDetail.videoURL = 'https://www.youtube.com/watch?v=' + this.currentVideoDetail.youtubeVideoId;
    if (initial) {
      this.startTimeValue();
      this.endTimeValue();
    }
    this.handleDuration();
  }

  /**
   * Load next video
   */
  loadNextVideo() {
    // Get current video position from playlist
  }
  /**
   * On playlist click
   * @param video video to be played
   */
  onPlaylistClick(video) {
    this.currentVideoDetail = video;
  }

  /**
   * Called when update consumed content
   * @param data data to be tracked
   */
  onUpdateConsumedContent(data) {
  }

  /**
 * Convert time to second
 * @param time time to be converted
 */
  convertTimeToSecond(time: any) {
    const timeInString = `${time.hour}:${time.minute}:${time.second}`;
    const splitTime = timeInString.split(':'); // split it at the colons

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    const seconds = (+splitTime[0]) * 60 * 60 + (+splitTime[1]) * 60 + (+splitTime[2]);
    return seconds;
  }

 /**
 * Convert secs to time string
 * @param secs to be converted
 */
  secondsToTime(secs)
  {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);

    const str = (hours < 10 ? '0'+hours : hours) + ':' + (minutes < 10 ? '0'+minutes : minutes) + ':' + (seconds < 10 ? '0'+seconds : seconds);

    return str;
  }

  /**
   * set default starttime
   * @returns 0 when user not entered starttime
   */
  startTimeValue() {
    this.videoForm.patchValue({
      startTime: {
        hour: 0,
        minute: 0,
        second: 0
      }
    });
    return 0;
  }


  /**
   * set default video endtime
   * @returns total video seconds
   */
  endTimeValue() {
    this.videoForm.patchValue({
      endTime: this.currentVideoDetail.duration ? this.currentVideoDetail.duration : 
      {        
        hour: 0,
        minute: 0,
        second: 0
      }
    });
    return this.totalVideoSeconds;
  }

  /**
   * set duration of video trim
   */
  handleDuration() {
    let isValidate: boolean = true;
    let startTimeInSecond;
    let endTimeInSecond;
    const startTime = this.videoForm.value.startTime;
    const endTime = this.videoForm.value.endTime;
    this.totalVideoSeconds = this.convertTimeToSecond(this.videoForm.value.duration);
    if (startTime) {
      startTimeInSecond = this.convertTimeToSecond(startTime);
      if (startTimeInSecond >= this.totalVideoSeconds) {
        this.startTimeErrorMessage = "Start time should not be bigger that video duration.";
        isValidate = false;
      } else {
        this.startTimeErrorMessage = null;
      }
    }

    if (endTime) {
      endTimeInSecond = this.convertTimeToSecond(endTime);
      if (endTimeInSecond > this.totalVideoSeconds) {
        this.endTimeErrorMessage = "End time should not be bigger than video duration.";
        isValidate = false;
      } else {
        this.endTimeErrorMessage = null;
      }
    }

    if (isValidate) {
      if (startTimeInSecond > endTimeInSecond) {
        this.startTimeErrorMessage = "Start time should not be bigger than End time";
        isValidate = false;
      } else {
        this.startTimeErrorMessage = null;
      }
    }

    if (isValidate && endTimeInSecond && (startTimeInSecond || startTimeInSecond == 0) ) {
      const durationInsec = endTimeInSecond - startTimeInSecond;
      this.duration = this.secondsToTime(durationInsec);
    } else {
      this.duration = "00:00:00";
    }
  }

  /**
   * Get video details from video id
   */
  /**
   * Derive the streaming platform + bare provider id from a canonical video
   * URL. Used at edit time where we can't trust the stored platForm/id fields
   * (e.g. AI drafts historically stored platForm='Other' for YouTube URLs).
   */
  private detectProviderFromUrl(url: string): { platForm: string; id: string } {
    if (!url) return { platForm: '', id: '' };
    try {
      const parsed = new URL(url);
      const host = parsed.hostname.toLowerCase();
      if (host === 'youtu.be') {
        const id = parsed.pathname.replace(/^\//, '').split(/[/?#]/)[0];
        if (id) return { platForm: 'YouTube', id };
      }
      if (host.endsWith('youtube.com')) {
        const id = parsed.searchParams.get('v')
          || (parsed.pathname.match(/\/(embed|shorts)\/([^/?#]+)/) || [])[2]
          || '';
        if (id) return { platForm: 'YouTube', id };
      }
      if (host.includes('spotify')) {
        return { platForm: 'Spotify', id: url };
      }
    } catch (_) { /* malformed URL — fall through */ }
    return { platForm: 'Other', id: url };
  }

  /**
   * Backfill live YouTube metadata onto the current videoForm when the DB
   * row was persisted without a usable duration (e.g. an AI draft created
   * before per-section trim was wired through the backend). This keeps the
   * edit page functional for pre-existing records — without this the
   * timepickers stay at 0, the slider can't scrub, and the embedded player
   * stops on the first `timeupdate` because `endTimeInSecond === 0`.
   */
  private healYoutubeDuration(
    youtubeId: string,
    storedStartTime: any,
    storedEndTime: any,
    storedStartSec: any,
    storedEndSec: any,
  ) {
    if (!youtubeId) { return; }
    this.createTangramService.getYoutubeVideoDetail(youtubeId).subscribe((data: any) => {
      if (!data || !Array.isArray(data.items) || !data.items.length) { return; }
      const [video] = data.items;
      const snippet = video.snippet || {};
      const contentDetails = video.contentDetails || {};
      const thumbnails = snippet.thumbnails || {};
      const freshDuration = this.youtubeDurationToHourMinuteSecond(contentDetails.duration || '');
      const freshTotalSec = this.convertTimeToSecond(freshDuration);
      if (freshTotalSec <= 0) { return; }

      const freshThumbnail = {
        smallURL: thumbnails.default ? thumbnails.default.url : '',
        mediumURL: thumbnails.medium ? thumbnails.medium.url : '',
      };

      // Only swap the thumbnail when the current form value is empty — never
      // clobber a user-supplied custom thumbnail that legitimately resolved
      // from the DB row.
      const existingThumbnail = this.videoForm.value.thumbnail || {};
      const patchedThumbnail = (existingThumbnail.smallURL || existingThumbnail.mediumURL)
        ? existingThumbnail
        : freshThumbnail;

      // Preserve any stored trim that looks valid; otherwise default to the
      // full video window so playback isn't locked out.
      const startSecNum = Number(storedStartSec) || 0;
      const endSecNum = Number(storedEndSec) || 0;
      const validStart = this.convertTimeToSecond(storedStartTime || { hour: 0, minute: 0, second: 0 }) > 0
        || startSecNum > 0;
      const validEnd = endSecNum > 0 && endSecNum <= freshTotalSec;
      const resolvedStart = validStart
        ? (storedStartTime || this.secondsToHmsObj(startSecNum))
        : { hour: 0, minute: 0, second: 0 };
      const resolvedEnd = validEnd
        ? (storedEndTime || this.secondsToHmsObj(endSecNum))
        : freshDuration;
      const resolvedStartSec = validStart ? startSecNum : 0;
      const resolvedEndSec = validEnd ? endSecNum : freshTotalSec;

      this.videoForm.patchValue({
        duration: freshDuration,
        thumbnail: patchedThumbnail,
        startTime: resolvedStart,
        endTime: resolvedEnd,
        startTimeInSecond: resolvedStartSec,
        endTimeInSecond: resolvedEndSec,
      });
      this.startTime = resolvedStart;
      this.endTime = resolvedEnd;

      // Rebuild currentVideoDetail so the embedded <tangram-video-detail>
      // player picks up the real duration and a valid trim window.
      this.handleCurrentVideo(false);
      this.videoDuration = this.secondsToTime(freshTotalSec);
      this.totalVideoSeconds = freshTotalSec;

      // Re-initialise the trim slider with the fresh duration so drag
      // bounds and the initial thumb positions reflect reality.
      setTimeout(() => {
        setDurationInit(resolvedStart, resolvedEnd, this.pageType, freshDuration);
      }, 0);
    });
  }

  /** Seconds → ngb-timepicker compatible { hour, minute, second }. */
  private secondsToHmsObj(seconds: number) {
    const s = Math.max(0, Math.floor(Number(seconds) || 0));
    return { hour: Math.floor(s / 3600), minute: Math.floor((s % 3600) / 60), second: s % 60 };
  }

  getVideoDetail() {
    this.createTangramService.getVideoDetail(this.videoId).subscribe((data: any) => {
      const { _id, youtubeVideoId, pathwayId, title, description, thumbnail, duration, tagId, startTime, endTime, startTimeInSecond, endTimeInSecond, platForm, videoURL } = data.data;

      // Derive platform + bare id from the canonical videoURL. This is more
      // reliable than trusting the stored platForm/youtubeVideoId combo,
      // which older AI drafts got wrong (platForm='Other' even for YouTube).
      const detected = this.detectProviderFromUrl(videoURL || youtubeVideoId || '');
      const resolvedPlatForm = detected.platForm || platForm || 'Other';
      const resolvedYoutubeId = detected.platForm === 'YouTube'
        ? detected.id
        : (youtubeVideoId || '');

      const resolvedStartTime = startTime || { hour: 0, minute: 0, second: 0 };
      const resolvedEndTime = endTime || duration || { hour: 0, minute: 0, second: 0 };

      this.videoForm.patchValue({
        _id: _id,
        pathwayId: pathwayId,
        videoType: '',
        // Keep the form's youtubeVideoId as bare id so the submit path
        // (data.youtubeVideoId = this.youtubeId) stays correct.
        youtubeVideoId: resolvedYoutubeId,
        title: title,
        order: '',
        description: description,
        thumbnail: thumbnail,
        duration: duration,
        tagId: tagId,
        startTime: resolvedStartTime,
        endTime: resolvedEndTime,
        startTimeInSecond: startTimeInSecond || 0,
        endTimeInSecond: endTimeInSecond || 0,
      });
      // ngb-timepicker uses `[(ngModel)]="startTime/endTime"` in the template,
      // and onSubmit reads those fields directly. Without syncing them to the
      // loaded values the user sees 00:00:00 and any Save overwrites the
      // existing trim with zeros.
      this.startTime = resolvedStartTime;
      this.endTime = resolvedEndTime;

      this.originalUrl = videoURL;
      this.pathwayId = pathwayId;
      this.platForm = resolvedPlatForm;
      this.youtubeId = resolvedPlatForm === 'YouTube' ? resolvedYoutubeId : (videoURL || youtubeVideoId || '');
      this.isYoutubeIdValid = resolvedPlatForm === 'YouTube' && !!resolvedYoutubeId;
      this.iFrameURL = this.getSafeUrl(videoURL);

      if (resolvedPlatForm === 'Other') {
        if (videoURL && (videoURL.includes('spreadsheets') || videoURL.includes('document') || videoURL.includes('drive'))) {
          const urlParts = videoURL.split('/');
          urlParts[urlParts.length - 1] = 'preview';
          const iframeURL = urlParts.join('/');
          this.iFrameURL = this.getSafeUrl(iframeURL);
        } else if (videoURL) {
          const enCodeURL = encodeURIComponent(videoURL);
          let newProxyURL = environment.proxyWorkerURL + '?id=1&interceptorNotNeeded=true&apiURL=' + enCodeURL;
          if (!environment.production) {
            newProxyURL = environment.proxyWorkerURL + '?id=2&interceptorNotNeeded=true&apiURL=' + enCodeURL;
          }
          this.iFrameURL = this.getSafeUrl(newProxyURL);
        }
      }

      if (resolvedPlatForm === 'YouTube') {
        this.handleCurrentVideo(false);
      }
      this.videoDuration = this.convertTimeToSecond(duration);
      this.videoDuration = this.secondsToTime(this.videoDuration);
      this.stratDuration = "00:00:00";
      if (this.isYoutubeIdValid) {
        // Defer setDurationInit so Angular has flushed the change detection
        // triggered by handleCurrentVideo(false) — otherwise the container
        // for #slider-1 / #slider-2 may still be invisible and the internal
        // jQuery DOM writes silently no-op. Also pass RESOLVED start/end
        // (raw backend values can be null and setDurationInit dereferences
        // `initStrat.hour` without a null-check, which throws and aborts the
        // whole init routine).
        const totalDuration = duration || { hour: 0, minute: 0, second: 0 };
        setTimeout(() => {
          setDurationInit(resolvedStartTime, resolvedEndTime, this.pageType, totalDuration);
        }, 0);

        // Self-heal YouTube items whose backend record has no usable duration
        // (old AI drafts created before per-section trim was persisted). Without
        // a real duration `handleCurrentVideo` leaves `endTimeInSecond=0`, which
        // makes the embedded player fire `ended` on the first `timeupdate` and
        // playback never starts; the trim slider also collapses to 00:00:00.
        // Re-fetch live YouTube metadata so the timepickers, slider, and player
        // become functional even on pre-existing broken rows.
        const storedTotalSec = this.convertTimeToSecond(totalDuration);
        const storedEndSec = Number(endTimeInSecond) || 0;
        if (storedTotalSec <= 0 || storedEndSec <= 0) {
          this.healYoutubeDuration(resolvedYoutubeId, startTime, endTime, startTimeInSecond, endTimeInSecond);
        }
      }
    },
    (err) => {
      this.toasterService.error('Media does not exist');
      this.router.navigate(['/home']);
    });
  }

  /**
   * Handle module flow based on route
   */
  handleFlow() {
    if (this.route.snapshot.routeConfig.path == 'edit-tangram-video/:videoId') {
      this.pageType = 'edit';
      this.route.params.subscribe((param) => {
        if (param && param.videoId) {
          this.videoId = param.videoId;
          this.getVideoDetail();
        } else {
          this.toasterService.error('Media does not exist');
          this.router.navigate(['/home']);
        }
      })
    } else if (this.route.snapshot.routeConfig.path == 'create-tangram') {
      this.pageType = 'create';
      this.route.queryParams
        .subscribe(params => {
          this.pathwayId = params.pathwayId ? params.pathwayId : '';
          // Restore active mode from query param
          const modeParam = params.mode as 'hyperlinks' | 'upload' | 'text' | 'canvas' | 'bulk';
          if (modeParam && ['hyperlinks', 'upload', 'text', 'canvas', 'bulk'].includes(modeParam)) {
            this.activeMode = modeParam;
            if (modeParam === 'canvas') this.checkCanvasStatus();
          }
        }
      );
    }
  }

  /**
   * Switch the active creation mode and update query params
   */
  switchMode(mode: 'hyperlinks' | 'upload' | 'text' | 'canvas' | 'bulk') {
    this.activeMode = mode;
    // Child components (upload/text/canvas) are destroyed and recreated via *ngIf,
    // so per-mode state resets automatically when switching tabs.
    // Use `replaceUrl: true` so repeated tab switches don't stack browser
    // history — otherwise the user has to press Back once per tab click
    // before actually leaving the page.
    // Reset mode-specific state when switching
    if (mode !== 'upload') { this.uploadedFile = null; this.isDragging = false; }
    if (mode !== 'text') {
      this.pastedText = '';
      this.musicPlaylistItems = [];
      this.aiRecommendations = [];
    }
    if (mode !== 'canvas') { this.canvasStep = 1; this.canvasSelectedCourse = null; this.canvasPages.forEach(p => p.selected = false); }
    if (mode === 'canvas' && !this.canvasConnected && this.canvasCourses.length === 0) {
      this.checkCanvasStatus();
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { mode },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  /**
   * Fetch Youtube video id from input string
   */
  getYoutubeId() {
    const strVal = this.videoForm.value.youtubeVideoId;
    let id = strVal;
    try {
      this.isYoutubeIdValid = true;
      if (strVal.includes('youtu.be')) {
        const url = (new URL(strVal));
        id = url.pathname.slice(1);
        this.platForm = 'YouTube'
      } else if (strVal.includes('youtube.com')) {
        const url = (new URL(strVal));
        const search = new HttpParams({ fromString: url.search.slice(1) });
        this.platForm = 'YouTube'
        id = search.get('v');
      }else if (strVal.includes('spotify')) {
        this.platForm = 'Spotify';
        this.isYoutubeIdValid = false;
      } else{
        this.platForm = 'Other'
        this.isYoutubeIdValid = false;
      }
      this.youtubeId = id;
    } catch(e) {
      this.isYoutubeIdValid = false;
      this.toasterService.error('Media does not exist');
      this.resetVideoForm();
    }
  }
  focusInputYoutube(){
    if(!this.isUserLoggedIn){
      this.router.navigate(['/login'],{queryParams : {returnUrl: '/create-tangram'}});
    }
  }
  getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  getInput(event){
    this.clickGetInfo = false
    if(!event.target.value && this.pageType == 'create'){
      this.resetVideoForm()
    }
    if (event && event.target && event.target.value) {
      this.aiRecommendations = [];
      this.similarContent = [];
      this.similarTangrams = [];
      this.aiContentOverview = '';
    }
  }

  generateSimilarContent(): void {
    const formValue = (this.videoForm && this.videoForm.value) || {};
    // Prefer the entered web link so the AI grounds suggestions in the
    // actual page metadata; fall back to title/description for non-URL flows.
    const seedInput = formValue.youtubeVideoId
      || formValue.title
      || formValue.description
      || this.pastedText
      || '';
    if (!seedInput) {
      this.toasterService.warning('Add a hyperlink or content details first.');
      return;
    }
    this.isSimilarContentLoading = true;
    this.aiService.getSimilarContent(seedInput, {
      pathwayId: this.pathwayId || undefined,
      videoId: this.videoId || undefined,
      mode: this.activeMode
    }).subscribe(
      (res: any) => {
        const items = (res && res.data && res.data.items) || [];
        this.similarContent = items.length
          ? items.map((item: any) => ({
              title: item.title || 'Related resource',
              url: item.url || '',
              source: item.source || 'AI',
              reason: item.reason || ''
            })).filter((item: any) => !!item.url)
          : this.buildSimilarContentFallback(seedInput);
        this.isSimilarContentLoading = false;
      },
      () => {
        this.similarContent = this.buildSimilarContentFallback(seedInput);
        this.isSimilarContentLoading = false;
      }
    );
    this.generateSimilarTangrams(seedInput);
    this.generateContentOverview();
  }

  generateAiRecommendations(): void {
    const sourceInput = this.activeMode === 'text' ? this.pastedText : ((this.videoForm && this.videoForm.value && this.videoForm.value.youtubeVideoId) || '');
    if (!sourceInput || !sourceInput.trim()) {
      this.toasterService.warning('Enter hyperlink or text to generate recommendations.');
      return;
    }
    this.isRecommendationLoading = true;
    this.aiService.getContentRecommendations({
      input: sourceInput,
      mode: this.activeMode,
      pathwayId: this.pathwayId || undefined,
      videoId: this.videoId || undefined
    }).subscribe(
      (res: any) => {
        const recommendations = (res && res.data && res.data.recommendations) || [];
        this.aiRecommendations = recommendations.length
          ? recommendations.map((item: any) => ({
              title: item.title || 'Suggested content',
              reason: item.reason || 'AI recommendation',
              url: item.url || ''
            }))
          : this.buildRecommendationFallback(sourceInput);
        this.isRecommendationLoading = false;
      },
      () => {
        this.aiRecommendations = this.buildRecommendationFallback(sourceInput);
        this.isRecommendationLoading = false;
      }
    );
  }

  runCuratorAssistant(): void {
    if (!this.isCuratorAssistantEnabled) {
      this.toasterService.info('Curator AI Assistant is temporarily disabled.');
      return;
    }
    this.curatorAssistantError = '';
    const sourceInput = this.assistantTopic.trim() || (this.videoForm && this.videoForm.value && this.videoForm.value.youtubeVideoId) || this.pastedText || '';
    if (!sourceInput.trim()) {
      this.toasterService.warning('Provide a topic or source content to run Curator AI Assistant.');
      return;
    }
    this.isCuratorAssistantLoading = true;
    this.aiService.getCuratorAssistantDraft({
      input: sourceInput,
      mode: this.activeMode,
      pathwayId: this.pathwayId || undefined
    }).subscribe(
      (res: any) => {
        this.isCuratorAssistantLoading = false;
        const draft = (res && res.data && res.data.draft) || {};
        const plan = (res && res.data && res.data.plan) || {};
        const currentTitle = (this.videoForm && this.videoForm.value && this.videoForm.value.title) || '';
        const currentDescription = (this.videoForm && this.videoForm.value && this.videoForm.value.description) || '';
        this.curatorDraft = {
          title: draft.title || currentTitle || 'AI-assisted Tangram Draft',
          description: draft.description || currentDescription || '',
          notes: (draft.notes && draft.notes.length) ? draft.notes : ['Review and edit AI suggestions before saving.']
        };
        this.curatorAssistantPlan = {
          modules: (plan.modules || []).map((item: any) => ({
            title: item.title || 'Suggested module',
            summary: item.summary || '',
            selected: true
          })),
          suggestedContent: (plan.suggestedContent || []).map((item: any) => ({
            title: item.title || 'Suggested content',
            url: item.url || '',
            reason: item.reason || 'Relevant to your topic',
            source: item.source || 'AI',
            selected: false
          })),
          missingTopics: plan.missingTopics || [],
          sequenceImprovements: plan.sequenceImprovements || []
        };
        if (!this.curatorAssistantPlan.modules.length) {
          this.curatorAssistantPlan.modules = this.buildRecommendationFallback(sourceInput).map((item) => ({
            title: item.title,
            summary: item.reason,
            selected: true
          }));
        }
        if (!this.curatorAssistantPlan.suggestedContent.length) {
          this.curatorAssistantPlan.suggestedContent = this.buildSimilarContentFallback(sourceInput).map((item) => ({
            title: item.title,
            url: item.url,
            source: item.source,
            reason: 'AI fallback suggestion',
            selected: false
          }));
        }
        this.assistantStepIndex = 2;
      },
      () => {
        // Primary endpoint fallback: keep guided flow working even if
        // /ai/curator-assistant is not available in this environment.
        this.curatorAssistantPlan = {
          modules: this.buildRecommendationFallback(sourceInput).map((item) => ({
            title: item.title,
            summary: item.reason,
            selected: true
          })),
          suggestedContent: this.buildSimilarContentFallback(sourceInput).map((item) => ({
            title: item.title,
            url: item.url,
            source: item.source,
            reason: 'AI fallback suggestion',
            selected: false
          })),
          missingTopics: [],
          sequenceImprovements: []
        };
        this.assistantStepIndex = 2;
        // Secondary AI fallback: reuse AI Summary endpoints when context exists.
        let request$ = null;
        const provider: 'gemini' = 'gemini';
        if (this.pathwayId) {
          request$ = this.aiService.getTangramSummary(this.pathwayId, provider);
        } else if (this.videoId) {
          request$ = this.aiService.getMediaSummary(this.videoId, provider);
        }

        if (!request$) {
          this.isCuratorAssistantLoading = false;
          this.curatorDraft = {
            title: this.videoForm.value.title || '',
            description: this.videoForm.value.description || '',
            notes: ['Curator Assistant API unavailable in this environment.', 'Review and edit AI suggestions before saving.']
          };
          this.curatorAssistantError = 'Using built-in guidance fallback because Curator Assistant API is unavailable.';
          return;
        }

        request$.subscribe(
          (summaryRes: any) => {
            this.isCuratorAssistantLoading = false;
            const summaryText = (summaryRes && summaryRes.data && summaryRes.data.summary) || '';
            this.curatorDraft = {
              title: this.videoForm.value.title || 'AI-assisted Tangram Draft',
              description: summaryText || this.videoForm.value.description || '',
              notes: ['Generated using AI Summary fallback.', 'Review and edit AI suggestions before saving.']
            };
            this.curatorAssistantPlan = {
              modules: this.buildRecommendationFallback(sourceInput).map((item) => ({
                title: item.title,
                summary: item.reason,
                selected: true
              })),
              suggestedContent: this.buildSimilarContentFallback(sourceInput).map((item) => ({
                title: item.title,
                url: item.url,
                source: item.source,
                reason: 'AI fallback suggestion',
                selected: false
              })),
              missingTopics: [],
              sequenceImprovements: []
            };
            this.assistantStepIndex = 2;
          },
          () => {
            this.isCuratorAssistantLoading = false;
            this.curatorDraft = {
              title: this.videoForm.value.title || '',
              description: this.videoForm.value.description || '',
              notes: ['Curator Assistant API unavailable in this environment.', 'Review and edit AI suggestions before saving.']
            };
            this.curatorAssistantError = 'Using built-in guidance fallback because Curator Assistant API is unavailable.';
          }
        );
      }
    );
  }

  applyCuratorDraft(): void {
    this.videoForm.patchValue({
      title: this.curatorDraft.title || this.videoForm.value.title,
      description: this.curatorDraft.description || this.videoForm.value.description
    });
    // Populate the preview editor so the user can review before re-applying
    if (this.curatorDraft.title)       { this.aiGeneratedTitle       = this.curatorDraft.title; }
    if (this.curatorDraft.description) { this.aiGeneratedDescription = this.curatorDraft.description; }
    this.toasterService.success('AI draft fields applied. Review and edit before saving.');
  }

  /** Feature 1 – Generate preview title & description without auto-patching the form */
  previewAiTitleAndDescription(provider: 'gemini' | 'openai' = this.lastAiTitleDescProvider || 'gemini'): void {
    const sourceText = this.videoForm.value.youtubeVideoId || this.pastedText || '';
    if (!sourceText.trim()) {
      this.toasterService.info('Add source text or media first so AI can generate a preview.');
      return;
    }
    this.lastAiTitleDescProvider = provider;
    this.isAiTitleDescLoading = true;
    this.aiTitleDescLoadingProvider = provider;
    this.aiGeneratedTitle       = '';
    this.aiGeneratedDescription = '';
    let titleDone = false;
    let descDone  = false;

    const checkDone = () => {
      if (titleDone && descDone) {
        this.isAiTitleDescLoading = false;
        this.aiTitleDescLoadingProvider = '';
      }
    };

    this.aiService.enhanceText({ text: sourceText, purpose: 'title',       audience: 'University students', tone: 'Clear and engaging', provider }).subscribe(
      (res: any) => {
        const t = ((res && res.data && (res.data.text || res.data.enhancedText)) || '').trim();
        if (t) { this.aiGeneratedTitle = t; }
        titleDone = true;
        checkDone();
      },
      () => { titleDone = true; checkDone(); }
    );

    this.aiService.enhanceText({ text: sourceText, purpose: 'description', audience: 'University students', tone: 'Clear and engaging', provider }).subscribe(
      (res: any) => {
        const d = ((res && res.data && (res.data.text || res.data.enhancedText)) || '').trim();
        if (d) { this.aiGeneratedDescription = d; }
        descDone = true;
        checkDone();
      },
      () => { descDone = true; checkDone(); }
    );
  }

  applyAiTitle(title: string): void {
    this.videoForm.patchValue({ title });
    this.toasterService.success('AI title applied. You can edit before saving.');
  }

  applyAiDescription(desc: string): void {
    this.videoForm.patchValue({ description: desc });
    this.toasterService.success('AI description applied. You can edit before saving.');
  }

  /** Feature 3 – Content recommendation with media-type filter */
  onRecommendationSearch(event: { topic: string; mediaType: string }): void {
    if (event.topic) { this.pastedText = event.topic; }
    this.isRecommendationLoading = true;
    this.aiRecommendations = [];
    this.aiService.getContentRecommendations({
      input: event.topic,
      mode: this.activeMode,
      pathwayId: this.pathwayId || undefined,
      videoId: this.videoId || undefined
    }).subscribe(
      (res: any) => {
        const recommendations = (res && res.data && res.data.recommendations) || [];
        this.aiRecommendations = recommendations.length
          ? recommendations.map((item: any) => ({
              title: item.title || 'Suggested content',
              reason: item.reason || 'AI recommendation',
              url: item.url || '',
              mediaType: item.mediaType || (event.mediaType !== 'all' ? event.mediaType : undefined)
            }))
          : this.buildRecommendationFallback(event.topic).map((r: any) => ({
              ...r,
              mediaType: event.mediaType !== 'all' ? event.mediaType : undefined
            }));
        this.isRecommendationLoading = false;
      },
      () => {
        this.aiRecommendations = this.buildRecommendationFallback(event.topic).map((r: any) => ({
          ...r,
          mediaType: event.mediaType !== 'all' ? event.mediaType : undefined
        }));
        this.isRecommendationLoading = false;
      }
    );
  }

  onAddRecommendedContent(item: { title: string; url?: string }): void {
    if (item.url) {
      this.addMusicToHyperlink(item.url);
      this.toasterService.success(`"${item.title}" added to your Tangram.`);
    } else {
      this.toasterService.info(`"${item.title}" noted. Paste a URL to add it.`);
    }
  }

  extractLinksAndPlaylistsFromText(): void {
    if (!this.pastedText || !this.pastedText.trim()) {
      this.toasterService.warning('Paste content first to extract links.');
      return;
    }
    const urlMatches = this.pastedText.match(/https?:\/\/[^\s]+/g) || [];
    this.musicPlaylistItems = urlMatches
      .filter((url: string) => this.getMusicPlatform(url) !== '')
      .map((url: string) => ({ platform: this.getMusicPlatform(url), url: url }));
    this.generateAiRecommendations();
  }

  addMusicToHyperlink(url: string): void {
    this.videoForm.patchValue({ youtubeVideoId: url });
    this.getPublicLinkDetails();
  }

  setAssistantStep(step: number): void {
    this.assistantStepIndex = step;
  }

  toggleModuleSelection(index: number): void {
    this.curatorAssistantPlan.modules[index].selected = !this.curatorAssistantPlan.modules[index].selected;
  }

  toggleSuggestedContent(index: number): void {
    this.curatorAssistantPlan.suggestedContent[index].selected = !this.curatorAssistantPlan.suggestedContent[index].selected;
  }

  useSuggestedContent(item: { title: string; url: string }): void {
    if (!item.url) {
      return;
    }
    this.videoForm.patchValue({ youtubeVideoId: item.url });
    this.getPublicLinkDetails();
    if (item.title && !this.videoForm.value.title) {
      this.videoForm.patchValue({ title: item.title });
    }
    this.toasterService.success('AI suggestion added to your media form. Review before saving.');
  }

  private getMusicPlatform(url: string): string {
    if (url.includes('spotify.com')) { return 'Spotify'; }
    if (url.includes('music.youtube.com')) { return 'YouTube Music'; }
    if (url.includes('youtube.com') || url.includes('youtu.be')) { return 'YouTube'; }
    if (url.includes('music.apple.com')) { return 'Apple Music'; }
    if (url.includes('soundcloud.com')) { return 'SoundCloud'; }
    return '';
  }

  generateContentOverview(): void {
    this.isContentOverviewLoading = true;
    this.aiService.getContentOverview({
      pathwayId: this.pathwayId || undefined,
      videoId: this.videoId || undefined,
      provider: 'gemini'
    }).subscribe(
      (res: any) => {
        this.aiContentOverview = ((res && res.data && res.data.overview) || '').trim();
        this.isContentOverviewLoading = false;
      },
      () => {
        this.aiContentOverview = '';
        this.isContentOverviewLoading = false;
      }
    );
  }

  generateSimilarTangrams(seedInput?: string): void {
    const input = seedInput || this.videoForm.value.title || this.videoForm.value.description || this.videoForm.value.youtubeVideoId || this.pastedText || '';
    if (!input) {
      this.similarTangrams = [];
      return;
    }
    this.isSimilarTangramsLoading = true;
    this.aiService.getSimilarTangrams({
      pathwayId: this.pathwayId || undefined,
      input: input,
      limit: 5
    }).subscribe(
      (res: any) => {
        const items = (res && res.data && res.data.items) || [];
        this.similarTangrams = (items || [])
          .filter((item: any) => !(item && (item.isPrivate || item.isInviteOnly || String(item.privacyOption || '').toLowerCase() === 'private')))
          .map((item: any) => ({
          title: item.title || 'Related Tangram',
          pathwayId: item.pathwayId || item._id || '',
          reason: item.reason || 'Matched by topic and content.'
        })).filter((item: any) => !!item.pathwayId);
        this.isSimilarTangramsLoading = false;
      },
      () => {
        this.similarTangrams = [];
        this.isSimilarTangramsLoading = false;
      }
    );
  }

  navigateToSimilarTangram(pathwayId: string): void {
    if (!pathwayId) {
      return;
    }
    this.router.navigate(['/dashboard', pathwayId]);
  }

  enhanceWithAi(field: 'title' | 'description', provider: 'gemini' | 'openai' = 'gemini'): void {
    const currentText = field === 'title' ? (this.videoForm.value.title || '') : (this.videoForm.value.description || '');
    const sourceText = currentText || this.videoForm.value.youtubeVideoId || this.pastedText || '';
    if (!sourceText.trim()) {
      this.toasterService.info('Add source text or media first so AI can improve it.');
      return;
    }
    if (field === 'title') {
      this.isEnhancingTitle = true;
      this.enhancingTitleProvider = provider;
    } else {
      this.isEnhancingDescription = true;
      this.enhancingDescriptionProvider = provider;
    }
    this.aiService.enhanceText({
      text: sourceText,
      purpose: field,
      audience: 'University students',
      tone: 'Clear and engaging',
      provider
    }).subscribe(
      (res: any) => {
        const enhanced = ((res && res.data && (res.data.text || res.data.enhancedText)) || '').trim();
        if (enhanced) {
          const patch: any = {};
          patch[field] = enhanced;
          this.videoForm.patchValue(patch);
          this.toasterService.success(`AI ${field} suggestion applied. You can edit before saving.`);
        }
        this.isEnhancingTitle = false;
        this.isEnhancingDescription = false;
        this.enhancingTitleProvider = '';
        this.enhancingDescriptionProvider = '';
      },
      () => {
        this.isEnhancingTitle = false;
        this.isEnhancingDescription = false;
        this.enhancingTitleProvider = '';
        this.enhancingDescriptionProvider = '';
      }
    );
  }

  private buildSimilarContentFallback(seedInput: string): Array<{ title: string; url: string; source: string }> {
    const q = encodeURIComponent((seedInput || '').split(' ').slice(0, 6).join(' '));
    return [
      { title: 'Related YouTube results', url: 'https://www.youtube.com/results?search_query=' + q, source: 'YouTube' },
      { title: 'Related Wikipedia topics', url: 'https://en.wikipedia.org/wiki/Special:Search?search=' + q, source: 'Wikipedia' },
      { title: 'Related Google results', url: 'https://www.google.com/search?q=' + q, source: 'Web' }
    ];
  }

  private buildRecommendationFallback(sourceInput: string): Array<{ title: string; reason: string; url?: string }> {
    const shortened = sourceInput.slice(0, 120);
    return [
      { title: 'Create foundational Tangram section', reason: 'Start with a concise intro from the provided source.' },
      { title: 'Add examples media item', reason: 'Include one applied example tied to: ' + shortened },
      { title: 'Add recap and reflection question', reason: 'Close with a checkpoint to improve retention.' }
    ];
  }
    showHyperlinkModal(){
    $("#hyperlinkModal").appendTo('body').modal('show');
  }
  
  closeModal() {
    const fileInput: HTMLInputElement = document.getElementById('fileInput') as HTMLInputElement;
    if(fileInput){
      fileInput.value = null;
    }
    // Clear the selected file when closing modal
    this.selectedFile = null;
    this.imageChangedEvent = '';
    // this.croppedImagePreview = '';
    this.displayStyle = 'none';
  }

  undoThumbnail(){
    this.savedThumbImage = '';
    this.selectedFile = null;
    this.imageChangedEvent = '';
    this.croppedImagePreview = '';
    // Reset the file input
    const fileInput: HTMLInputElement = document.getElementById('fileInput') as HTMLInputElement;
    if(fileInput){
      fileInput.value = null;
    }
  }

  fileChangeEvent(event: any): void {
    const fileList: FileList = event.target.files;
    // console.log('fileList: ', fileList);
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const fileSize: number = file.size; // File size in bytes
      const maxSize: number = 2 * 1024 * 1024; // 2MB in bytes

      // Check file type
      const fileType: string = file.type;
      if (fileType !== 'image/png' && fileType !== 'image/jpeg' ) {
        this.toasterService.error('Only PNG and JPEG files are allowed.');
        event.target.value = ''; // Reset the input field to clear the selected file
        return;
      }
      
      // Check file size
      if (fileSize > maxSize) {
        this.toasterService.error(`File size exceeds ${maxSize / (1024 * 1024)}MB. Please select a smaller file.`)
        event.target.value = ''; // Reset the input field to clear the selected file
        return;
      }

      // Store the file for later use
      this.selectedFile = file;
      
      // Set the imageChangedEvent to trigger the image cropper
      this.imageChangedEvent = event;
      
      // Open the crop modal
      this.openModal();
    }
  }

  openModal() {
    this.displayStyle = 'block';
  }

  imageCropped(event: ImageCroppedEvent) {
    // Store base64 preview for display
    if (event.base64) {
      this.croppedImagePreview = event.base64;
      // Convert base64 to file object for direct upload
      this.base64ToFile(event.base64, 'thumbnail.jpg').then(file => {
        this.savedThumbImage = file;
      });
    }
  }

  base64ToFile(base64: string, filename: string): Promise<File> {
    return new Promise((resolve) => {
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file = new File([u8arr], filename, { type: mime });
      resolve(file);
    });
  }


  imageCroppedError(event: any) {
    console.error('Image cropper error:', event);
    this.toasterService.error('Error cropping image. Please try again.');
  }

  imageCroppedCancel() {
    this.closeModal();
  }

  saveCroppedImage() {
    if (this.savedThumbImage) {
      this.toasterService.success('Thumbnail image cropped successfully');
      this.closeModal();
      // Keep the preview for display until form is reset
    } else {
      this.toasterService.error('Please crop the image first');
    }
  }

  openUnlockPremium(modalContent: TemplateRef<any>){
    this.modalService.open(modalContent, { centered: true, windowClass : 'unlock-premium' })
  }

  openAlertPopup(message: string) {
    this.alterMessage = message;
    this.modalService.open(this.alertContent, { centered: true, windowClass: 'unlock-premium' });
  }

  navigateToPricing(){
    this.modalService.dismissAll()
    this.router.navigate(['/home/payment-page']);
  }

  getConfigurations() {
    // Get pathway list by using users service
    this.configurationService.getConfigurationsList().subscribe((res: any) => {
      if (res.data) {
        const data = res.data;
        this.maxBasicTangram = data.maxBasicTangram;
        this.maxBasicMedia = data.maxBasicMedia;
        this.maxPremiumTangram = data.maxPremiumTangram;
        this.maxPremiumMedia = data.maxPremiumMedia;
      }
    });
  }

  /**
   * Handle password toggle change
   */
  onPasswordToggleChange() {
    if (this.isPasswordProtected) {
      // Open password modal when toggle is enabled
      this.openPasswordModal();
    } else {
      // Clear password when toggle is disabled
      this.tangramPassword = '';
      this.confirmPassword = '';
      this.passwordError = '';
    }
  }

  /**
   * Open password modal
   */
  openPasswordModal() {
    this.passwordError = '';
    this.tangramPassword = '';
    this.confirmPassword = '';
    this.modalService.open(this.passwordModalContent, { centered: true });
  }

  /**
   * Set password for Tangram
   */
  setPassword(modal: any) {
    this.passwordError = '';

    // Validate password
    if (!this.tangramPassword || this.tangramPassword.length < 4) {
      this.passwordError = 'Password must be at least 4 characters long';
      return;
    }

    if (this.tangramPassword !== this.confirmPassword) {
      this.passwordError = 'Passwords do not match';
      return;
    }

    // Password is valid, mark as set and close modal
    this.isPasswordSet = true;
    modal.close('Password Set');
  }

  /**
   * Check if privacy settings should be shown
   */
  shouldShowPrivacySettings(): boolean {
    return this.pageType === 'create' && !this.pathwayId
  }

  /**
   * Handle privacy option selection
   */
  onPrivacyOptionSelect(optionId: string) {
    this.selectedPrivacyOption = optionId;
    
    // Handle password protected option
    if (optionId === PRIVACY_OPTIONS.PASSWORD_PROTECTED) {
      this.isPasswordProtected = true;
    } else {
      this.isPasswordProtected = false;
      this.isPasswordSet = false; // Reset password set status when switching away
      this.tangramPassword = '';
      this.confirmPassword = '';
      this.passwordError = '';
    }
    
    // Handle invite only option - automatically open modal
    if (optionId === PRIVACY_OPTIONS.INVITE_ONLY) {
      this.openInviteModal();
    }
  }

  /**
   * Handle password set event from shared component
   */
  onPasswordSet(event: { pathwayId: string, password: string }) {
    this.tangramPassword = event.password;
    this.isPasswordSet = true;
    this.isPasswordProtected = true;
  }

  /**
   * Handle password changed event from shared component
   */
  onPasswordChanged(event: { pathwayId: string, password: string }) {
    this.tangramPassword = event.password;
    this.isPasswordSet = true;
    this.isPasswordProtected = true;
  }

  /**
   * Handle password removed event from shared component
   */
  onPasswordRemoved(pathwayId: string) {
    this.isPasswordSet = false;
    this.isPasswordProtected = false;
    this.tangramPassword = '';
    this.confirmPassword = '';
    this.passwordError = '';
    this.selectedPrivacyOption = PRIVACY_DEFAULTS.PRIVACY_OPTION;
  }

  /**
   * Open invite modal
   */
  openInviteModal() {
    this.inviteError = '';
    this.newInviteEmail = '';
    this.newInvitedEmails = [];
    this.inviteMessage = '';
    this.modalService.open(this.inviteModalContent, { centered: true, size: 'lg' });
  }

  /**
   * Add email to new invite list
   */
  addInviteEmail() {
    if (this.newInviteEmail && this.newInviteEmail.trim()) {
      const email = this.newInviteEmail.trim().toLowerCase();
      
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        this.inviteError = 'Please enter a valid email address';
        return;
      }
      
      // Check if email already exists
      if (this.newInvitedEmails.includes(email)) {
        this.inviteError = 'This email is already in the list';
        return;
      }
      
      this.newInvitedEmails.push(email);
      this.newInviteEmail = '';
      this.inviteError = '';
    }
  }

  /**
   * Remove email from new invite list
   */
  removeNewInviteEmail(index: number) {
    this.newInvitedEmails.splice(index, 1);
  }

  /**
   * Handle invite modal closed
   */
  onInviteModalClosed(modal: any) {
    modal.close('Cancel');
  }

  /**
   * Handle invites sent from modal
   */
  onInvitesSent(inviteData: any, modal?: any) {
    // Store the invite data for later use
    this.invitedEmails = inviteData.emails.map((emailObj: any) => ({
      email: emailObj.email,
      accessType: emailObj.accessType || 'viewer',
      message: inviteData.message
    }));

    this.toasterService.success(`Invitations prepared for ${inviteData.emails.length} people! They will be sent after the Tangram is created.`);
    if (modal) { modal.close('Invitations Prepared'); }
  }

  /**
   * Remove invited email from the list
   */
  removeInvitedEmail(index: number) {
    this.invitedEmails.splice(index, 1);
  }

  /**
   * Send invite only invitations after tangram creation
   */
  sendInviteOnlyInvitations(pathwayId: string) {
    if (this.invitedEmails.length === 0) {
      return;
    }

    const emails = this.invitedEmails.map(invite => ({
      email: invite.email,
      accessType: invite.accessType || 'viewer'
    }));
    console.log("this.invitedEmails", this.invitedEmails)
    const message = this.invitedEmails.length > 0 ? this.invitedEmails[0].message || '' : '';

    // Call the dashboard service to send invitations
    this.createTangramService.sendInviteOnlyInvitations(pathwayId, emails, message)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.toasterService.success(`Invitations sent to ${emails.length} people successfully!`);
          } else {
            this.toasterService.error('Failed to send some invitations');
          }
        },
        (error) => {
          this.toasterService.error('Error sending invitations');
        }
      );
  }

}
